import { domain, packValidateResults, required } from 'helpers/validators';
import { CheckoutDomainEditProps } from 'services/API/Checkout_Domain/interface';

export const validate = (data: CheckoutDomainEditProps) =>
  packValidateResults([
    required(data, ['name', 'domain_pattern', 'protocol']),
    domain(data, ['domain_pattern'], { allowWildcard: true }),
  ]);
